import React  from 'react';

const PayPalButton = (props) => {
	return <img src="https://checkout.paypal.com/pwpp/2.21.0/images/pay-with-paypal.png" />;
}

export default PayPalButton;


// WEBPACK FOOTER //
// ./src/components/PayPalButton.jsx